import {
  BrandCampaignsWrapper,
  CampaignContainer,
  MemberCampaignsWrapper,
} from '@retail/campaign/containers';
import { PageLayout } from '@retail/components';
import { useSelectedOrgUnit } from '@retail/app/stores/selected-context';

export function CampaignsPage() {
  const { isBrandContext } = useSelectedOrgUnit();

  return (
    <PageLayout maxWidth="full" spacing={2} fixedHeight>
      {isBrandContext ? (
        <BrandCampaignsWrapper>
          {(props) => <CampaignContainer {...props} type="brand" />}
        </BrandCampaignsWrapper>
      ) : (
        <MemberCampaignsWrapper>
          {(props) => <CampaignContainer {...props} type="member" />}
        </MemberCampaignsWrapper>
      )}
    </PageLayout>
  );
}
